import { Typography } from "@material-ui/core";

export function NoRouteFound(): JSX.Element {
  return (
    <Typography variant="h3" align="center">
      Sorry, this page does not exist.
    </Typography>
  );
}
